import React from "react";
import { FiWifi } from "react-icons/fi";

/** A realistic phone frame; `children` are the screen. */
export default function PhoneFrame({ children, className = "" }) {
  return (
    <div className={`phone-real ${className}`} aria-hidden="true">
      <span className="phone-real__btn phone-real__btn--power" />
      <span className="phone-real__btn phone-real__btn--vol" />
      <div className="phone-real__screen">
        <div className="phone-real__status">
          <span>9:41</span>
          <span className="phone-real__status-right">
            <FiWifi /> <i className="phone-real__battery" />
          </span>
        </div>
        <span className="phone-real__notch" />
        {children}
      </div>
    </div>
  );
}
